import authMiddleware from '~auth/core/middleware'
import Middleware from './middleware'
import Auth from '~auth/core/auth'
import ExpiredAuthSessionError from '~auth/inc/expired-auth-session-error'

// Active schemes
import scheme_5f2432aa from '~auth/schemes/local'
import scheme_2df8eb24 from '~auth/schemes/cookie'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {"resetOnError":false,"scopeKey":"scope","rewriteRedirects":true,"fullPathRedirect":false,"watchLoggedIn":true,"redirect":{"login":"/auth/login","logout":"/auth/login","home":"/","callback":"/auth/login"},"vuex":{"namespace":"auth"},"cookie":{"prefix":"auth.","options":{"path":"/"}},"localStorage":{"prefix":"auth."},"defaultStrategy":"local"}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new scheme_5f2432aa($auth, {"token":{"property":"token","maxAge":5184000},"user":false,"endpoints":{"login":{"url":"/api-v3/auth/login.php","method":"post"},"logout":{"url":"api-v3/auth/logout.php","method":"post"},"user":false},"name":"local"}))

  // cookie
  $auth.registerStrategy('cookie', new scheme_2df8eb24($auth, {"cookie":{"name":"PHPSESSID"},"user":false,"endpoints":{"login":{"url":"/api-v1/user/authorization","method":"post"},"logout":false,"user":false},"name":"cookie"}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
